import { AlertTriangle, FolderInput, KeyRound, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/modals/Modal";

export function RemoveMemberModal({ open, onClose, member, onConfirm, busy }) {
  if (!member) return null;

  return (
    <Modal
      open={open}
      onClose={busy ? () => {} : onClose}
      title="Remove Teacher"
      subtitle="This action cannot be undone."
      icon={<AlertTriangle size={16} className="text-destructive" />}
      maxWidth="max-w-md"
      preventClose={busy}
    >
      <div className="px-6 py-5 space-y-4">
        <div className="rounded-lg border border-border bg-muted/30 px-4 py-3">
          <p className="text-sm font-semibold text-foreground truncate">{member.name}</p>
          <p className="text-xs text-muted-foreground truncate">{member.email}</p>
        </div>

        <div>
          <p className="text-sm font-medium text-foreground mb-2.5">
            Removing this teacher will:
          </p>
          <ul className="space-y-2.5">
            <li className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-lg bg-accent flex items-center justify-center text-primary shrink-0 mt-0.5">
                <FolderInput size={14} />
              </div>
              <p className="text-sm text-muted-foreground leading-snug pt-1">
                Transfer <span className="font-medium text-foreground">all of their Report Folders to you</span>.
                You become the new owner and can reassign them later.
              </p>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-lg bg-accent flex items-center justify-center text-primary shrink-0 mt-0.5">
                <KeyRound size={14} />
              </div>
              <p className="text-sm text-muted-foreground leading-snug pt-1">
                Free up their <span className="font-medium text-foreground">School Plan seat</span> so
                you can assign it to another teacher.
              </p>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-lg bg-accent flex items-center justify-center text-primary shrink-0 mt-0.5">
                <Wallet size={14} />
              </div>
              <p className="text-sm text-muted-foreground leading-snug pt-1">
                Revoke their access to anything shared in this school. They keep their{" "}
                <span className="font-medium text-foreground">personal credits</span>.
              </p>
            </li>
          </ul>
        </div>

        <div className="flex gap-2 pt-1">
          <Button variant="destructive" disabled={busy} onClick={onConfirm}>
            {busy ? "Removing…" : "Remove Teacher"}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
